import React from 'react';
import { Card, makeStyles } from '@material-ui/core';
import { DpCardTitleActions } from './DpCardTitleActions';
import { DpCardFilters } from './DpCardFilters';
import { DpCardFooter } from './DpCardFooter';

const useStyles = makeStyles((theme) => ({
  cardWrapper: {
    padding: theme.spacing(1.5),
    width: '100%',
    height: '100%',
    boxSizing: 'border-box',
  },
  cardRoot: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    width: '100%',
    borderRadius: '12px',
    transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
    boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
    '&:hover': {
      boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
    },
  },
  newCard: {
    backgroundColor: '#f9f9f9',
    border: '2px dashed #e0e0e0',
    minHeight: '300px',
    justifyContent: 'center',
    alignItems: 'center',
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: '#f1f1f1',
      borderColor: theme.palette.primary.main,
    },
  },
}));

/**
* @fileoverview Componente tarjeta contenedora para widgets del Panel Dinámico.
* @module DpCard
*/

/**
* Componente DpCard.
*
* Contenedor genérico para los widgets del dashboard. Proporciona una estructura
* visual uniforme con estilos predefinidos y maneja la presentación base de
* las tarjetas, diferenciando entre tarjetas de contenido y tarjetas de "nueva ranura".
*
* @param {Object} props - Propiedades del componente.
* @param {React.ReactNode} props.children - Contenido de la tarjeta.
* @param {boolean} [props.isNewCard=false] - Indica si es una tarjeta placeholder para añadir nuevo contenido.
*
* @returns {React.ReactElement} Tarjeta material-ui estilizada.
*
* @author David Maldonado
* (c) Servicios de Monitoreo S.A. - Santiago, Chile
*/ 
const DpCard = React.memo(function DpCard({ children, isNewCard = false, style = {} }) {
  const classes = useStyles();

  return (
    <div className={classes.cardWrapper}>
      <Card
        className={`${classes.cardRoot} ${isNewCard ? classes.newCard : ''}`}
        elevation={0}
        style={style}
      >
        {children}
      </Card>
    </div>
  );
});

DpCard.TitleActions = DpCardTitleActions;
DpCard.Filters = DpCardFilters;
DpCard.Footer = DpCardFooter;

export default DpCard;